/* istanbul ignore file */
// This is for testing only. The app will use the time zone returned from CMS.
export enum TimeZones {
  Auckland = "Pacific/Auckland",
  Sydney = "Australia/Sydney"
}
